// client/src/components/pages/ProductMovement/formatTonnes.ts
// Compact tonnage for cards, chart labels and treemap tiles (moved out of index.tsx, ST-00236).

export const formatTonnes = (val: number | null | undefined): string => {
  if (val == null) return '—';
  if (val >= 1000000) return `${(val / 1000000).toFixed(1)}M`;
  if (val >= 1000) return `${(val / 1000).toFixed(1)}K`;
  return val.toFixed(1);
};

export default formatTonnes;
